import Input from "../../controls/Input";
import SelectMenu from "../../controls/SelectMenu";
import { useForm } from "../useForm";
import { useEffect, useState } from "react";
import {
  formatDateWithTime,
  labSampleStatusOptions,
} from "../../../shared/utility";
import ButtonSpinner from "../../controls/ButtonSpinner";
import MediaUi from "../../importMedia/MediaUi";
import DatePickerInput from "../../controls/DatePickerInput";

const initialFValues = {
  name: "",
  correct_items: [],
  wrong_items: [],
  items_missing: [],
  status: { value: -1, label: "" },
  laboratory: {},
  lab_date: null,
  completed_date: null,
  lot_number: null,
  plu: null,
  product_name: null,
  weight_in_kg: null,
  weight_in_lbs: null,
  piece_count: null,
  barcode: null,
  uploaded_media_1: null,
  uploaded_media_2: null,
  uploaded_media_3: null,
  created_by_name: "",
};

export default function LabSampleDetailsForm(props) {
  const { inProgress, labs, labSample, updateLabSample } = props;

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === null);
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    true,
    validate
  );

  useEffect(() => {
    // Guard: labSample may be undefined when the component first mounts
    if (!labSample) return;

    const statusSelected = labSampleStatusOptions.find(
      (el) => el.value === labSample.status
    );

    setValues({
      ...labSample,
      status: statusSelected || { value: -1, label: "" },
      laboratory: labSample.laboratory
        ? { value: labSample.laboratory.id, label: labSample.laboratory.name }
        : {},
    });
  }, [labSample]);

  const [media1, setMedia1] = useState(null);
  const [media2, setMedia2] = useState(null);
  const [media3, setMedia3] = useState(null);
  return (
    <div className="justify-between">
      <div className="hide-for-print">
        <div>
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Lab Sample: #{labSample?.id}
          </h3>
        </div>
      </div>

      <div className="pt-6 pb-5 grid grid-cols-1 gap-2">
        <div className="p-4 card-custom space-y-5">
          <div className="grid sm:grid-cols-4 gap-4">
            <SelectMenu
              handleInputChange={handleInputChange}
              name="laboratory"
              options={labs}
              value={values.laboratory}
              title={"Laboratory"}
              error={errors.laboratory}
              showLabel={true}
              disabled={values.status.value > 0}
            />

            <DatePickerInput
              label="Lab submission date"
              name="lab_date"
              onChange={handleInputChange}
              value={values.lab_date}
              labelOn={true}
              dateFormat="LLL dd, YYY"
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />

            <Input
              onChange={handleInputChange}
              label="Created by"
              name="created_by_name"
              value={values.created_by_name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
            />

            <SelectMenu
              handleInputChange={handleInputChange}
              name="status"
              options={labSampleStatusOptions}
              value={values.status}
              title={"Status"}
              error={errors.status}
            />

            <Input
              onChange={handleInputChange}
              label="Lot number"
              name="lot_number"
              value={values.lot_number}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
            />

            <Input
              onChange={handleInputChange}
              label="Product name"
              name="product_name"
              value={values.product_name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
            />

            <Input
              onChange={handleInputChange}
              label="PLU"
              name="plu"
              value={values.plu}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
            />

            <DatePickerInput
              label="Lab Completed date"
              name="completed_date"
              onChange={handleInputChange}
              value={values.completed_date}
              labelOn={true}
              dateFormat="LLL dd, YYY"
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="grid sm:grid-cols-4 gap-4">
            <Input
              onChange={handleInputChange}
              label="Amount in kg"
              name="weight_in_kg"
              value={values.weight_in_kg}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
            />

            <Input
              onChange={handleInputChange}
              label="Amount in lbs"
              name="weight_in_lbs"
              value={values.weight_in_lbs}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
            />

            <Input
              onChange={handleInputChange}
              label="Amount in pieces"
              name="piece_count"
              value={values.piece_count}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
            />

            <Input
              onChange={handleInputChange}
              label="Barcode"
              name="barcode"
              value={values.barcode}
              labelOn={true}
              type="text"
              parentClass="col-span-2"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
            />
            <Input
              onChange={handleInputChange}
              label="Notes"
              name="notes"
              value={values.notes}
              labelOn={true}
              type="text"
              parentClass="col-span-2"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
            />
          </div>
        </div>

        <div className="px-2 py-4 sm:px-5 card-custom grid grid-cols-1 sm:grid-cols-3 gap-4">
          <MediaUi
            title="Document 1"
            uploadedImage={media1}
            setUploadedImage={setMedia1}
            isEdit={true}
            imageUrl={values.media_1_url}
            imageName="uploaded_media_1"
            handleInputChange={handleInputChange}
            onDelete={() => {
              setValues({
                ...values,
                uploaded_media_1: null,
                media_1: "",
                media_1_url: null,
              });
              setMedia1(null);
            }}
          />

          <MediaUi
            title="Document 2"
            uploadedImage={media2}
            setUploadedImage={setMedia2}
            isEdit={true}
            imageUrl={values.media_2_url}
            imageName="uploaded_media_2"
            handleInputChange={handleInputChange}
            onDelete={() => {
              setValues({
                ...values,
                uploaded_media_2: null,
                media_2: "",
                media_2_url: null,
              });
              setMedia2(null);
            }}
          />

          <MediaUi
            title="Document 3"
            uploadedImage={media3}
            setUploadedImage={setMedia3}
            isEdit={true}
            imageUrl={values.media_3_url}
            imageName="uploaded_media_3"
            handleInputChange={handleInputChange}
            onDelete={() => {
              setValues({
                ...values,
                uploaded_media_3: null,
                media_3: "",
                media_3_url: null,
              });
              setMedia3(null);
            }}
          />
        </div>
        <div>
          <button
            type="button"
            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-main-purple hover:bg-indigo-700 items-center mt-3"
            onClick={() => updateLabSample(values)}
          >
            <ButtonSpinner spin={inProgress} text="Save" />
          </button>
        </div>
      </div>
    </div>
  );
}
